import { HelpOutline as HelpOutlineIcon, Settings as SettingsIcon } from "@mui/icons-material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelf } from "../../../../common/hooks/useSelf";
import { Routes } from "../../../root/routes";
import { LogoutMenuItem } from "./LogoutMenuItem";
import { UserNavItem } from "./UserNavItem";

type GetCompliantHeaderNavProps = {
  useMinimalNav: boolean;
};

export const GetCompliantHeaderNav: React.FC<GetCompliantHeaderNavProps> = ({
  useMinimalNav = false,
}) => {
  const [self] = useSelf();
  const isLoggedIn = Boolean(self);

  return (
    <div className="header-nav">
      <div className="header-nav__logo">
        <Link to={Routes.getCompliant.dashboard} aria-label="Go to dashboard">
          <img src="/assets/images/truevault-logo-print.png" height="33px" alt="TrueVault Logo" />
        </Link>
      </div>

      <div className="header-nav__items">
        {isLoggedIn && !useMinimalNav && (
          <div>
            <UserNavItem horizontal={false} />
          </div>
        )}

        {isLoggedIn && !useMinimalNav && (
          <SettingsMenuItem settingsRoute={Routes.getCompliant.settings.root} />
        )}
        <HelpMenuItem />
        {isLoggedIn && <LogoutMenuItem />}
      </div>
    </div>
  );
};

type SettingsMenuItemProps = {
  settingsRoute: string;
};
const SettingsMenuItem: React.FC<SettingsMenuItemProps> = ({ settingsRoute }) => {
  const location = useLocation();
  const isSettings = location.pathname.startsWith(settingsRoute);

  return (
    <div>
      <Link to={settingsRoute} className="primary-nav__bottom-link">
        <SettingsIcon
          className={`primary-nav__bottom-icon ${
            isSettings ? "primary-nav__bottom-icon--selected" : ""
          }`}
        />
        <span className={isSettings ? "text-weight-black" : ""}>Settings</span>
      </Link>
    </div>
  );
};

const HelpMenuItem = () => {
  return (
    <div>
      <div className="primary-nav__bottom-link" onClick={() => (window as any).Beacon("open")}>
        <HelpOutlineIcon className="primary-nav__bottom-icon" />
        <span>Help</span>
      </div>
    </div>
  );
};
